import {
  BookOpenCheck,
  GraduationCap,
  Home,
  Palette,
  UserRound,
  Ticket,
  Award,
} from 'lucide-react';

export const LEARN_DOCK_ITEMS = [
  { to: '/learn', label: 'Home', icon: Home },
  { to: '/learn/study', label: 'Study', icon: BookOpenCheck },
  { to: '/learn/create', label: 'Create', icon: Palette },
  { to: '/learn/classroom', label: 'Classes', icon: GraduationCap },
  { to: '/learn/my', label: 'My', icon: UserRound },
] as const;

export const WALK_IN_DOCK_ITEMS = [
  { to: '/learn/classroom', label: 'My Classes', icon: GraduationCap },
  { to: '/learn/passport', label: 'Passport', icon: Award },
  { to: '/learn/profile', label: 'My code', icon: Ticket },
] as const;

/** One content owner, even when the child opens a bookmarked deep route. */
export function learnSectionPath(pathname: string): string {
  if (/^\/learn\/(study|exams|academy|hsc)(\/|$)/.test(pathname)) return '/learn/study';
  if (/^\/learn\/(classroom|missions|wall|challenge)(\/|$)/.test(pathname))
    return '/learn/classroom';
  if (
    /^\/learn\/(create|gallery|playground|blocks|code|music|video|story|courses)(\/|$)/.test(
      pathname,
    )
  )
    return '/learn/create';
  if (/^\/learn\/(my|projects|passport|profile|account|workspace)(\/|$)/.test(pathname))
    return '/learn/my';
  return '/learn';
}

/** Source and analysis/notes readers own their back navigation and writing space. */
export function isStudyMaterialReader(pathname: string): boolean {
  return /^\/learn\/study\/materials\/[^/]+(?:\/analysis)?\/?$/.test(pathname);
}
